import layout from '../templates/layout';
import section from '../utils/section';
import Cookies from 'js-cookie';
import chart from 'chart.js';
export default class Publishersdashboard {
  constructor() {
    this.path = encodeURIComponent(window.location.pathname);
    this.dataurl = '/feeds/analytics/feed.html';
    this.pageviewsloaded = false;
    this.sourcesloaded = false;
    this.landingloaded = false;
    this.timeonpageloaded = false;
    this.contentsummaryloaded = false;
    this.mediumloaded = false;
    this.pageviewsdivclass = 'analytics-pageviews';
    this.sourcedivclass = 'analytics-source';
    this.mediumdivid = 'analytics-medium';
    this.landingdivclass = 'analytics-landing';
    this.timeonpagedivclass = 'analytics-timeonpage';
    this.contentsummaryid = 'analytics-contentsummary';
    this.loadersrc = '/3t4/img/graph-loader.gif';
    try {
      console.log(section.isinternalvisitor());
      section.isinternalvisitor() ? this.initialize() : false;
      //this.initialize()
    } catch (error) {
      console.log(error);
    }
  }
  initialize() {
    const analyticscolumn1content = `

        <div class="row">
        <div class="column large-12 medium-12 small-12" id="${this.mediumdivid}">
            <h2>Top medium</h2>
            <img id="${this.mediumdivid}-loader" src="${this.loadersrc}" />
            <canvas id="analytics-medium-chart"></canvas>
        </div>
    </div>
</div>

            `;
    const analyticscolumn2content = `
            <div class="row">
                <div class="column large-12 medium-12 small-12 ${this.sourcedivclass}">
                    <h2>Top sources</h2>
                    <img id="${this.sourcedivclass}-loader" src="${this.loadersrc}" />
                    <canvas id="analytics-sources-chart" style="height:200px"></canvas>
                </div>
            </div>
          <!--  <div class="row">
            <div class="column large-12 medium-12 small-12">
                <h2>Content summary</h2>
                <div id="${this.contentsummaryid}"></div>
            </div>         
        </div>-->  
`;

    const analyticscolumn3content = `
        <div class="row">
        <div class="column large-12 medium-12 small-12">
            <h2>Pageviews</h2>
            <img id="${this.pageviewsdivclass}-loader" src="${this.loadersrc}" />
            <canvas id="analytics-pageviews-chart"></canvas>
        </div>
    </div>

     <!--   <div class="row">
            <div class="column large-12 medium-12 small-12">
                <h2>Get help</h2>
                <select>
                    <option value="">select request type...</option>
                    <option value="rewrite">short url</option>
                    <option value="report">report an issue</option>
                </select>
                <form>
                    <textarea id="dashboard-input" name="input"></textarea>
                </form>
            </div>
        </div>-->
        `;

    const analyticscolumn4content = `
        <div class="row">
            <div class="column large-12 medium-12 small-12 ${this.landingdivclass}">
                <h2>Top landing pages</h2>
                <img id="${this.landingdivclass}-loader" src="${this.loadersrc}" />
            </div>
        </div>
        `;
    this.analyticscontainer = layout.row({
      elements: [
        layout.row({
          elements: [
            layout.column({
              elements: [`<h2>Analytics [beta]</h2>`],
              large: 12,
              medium: 12,
              small: 12,
            }),
          ],
          id: 'analytics-dashboard-header',
          classes: [],
        }),
        layout.row({
          elements: [
            layout.column({
              elements: [analyticscolumn1content],
              large: 4,
              medium: 4,
              small: 12,
            }),
            layout.column({
              elements: [analyticscolumn2content],
              large: 4,
              medium: 4,
              small: 12,
            }),
            layout.column({
              elements: [analyticscolumn3content],
              large: 4,
              medium: 4,
              small: 12,
            }),
            `<div class="analytics-dashboard-close">close</div`,
          ],
          id: 'analytics-dashboard-row1',
          classes: ['analytics-dashboard-row'],
        }),
        layout.row({
          elements: [
            layout.column({
              elements: [analyticscolumn4content],
              large: 8,
              medium: 8,
              small: 12,
            }),
          ],
          id: 'analytics-dashboard-row2',
          classes: ['analytics-dashboard-row'],
        }),
      ],
      classes: [],
      id: 'analytics-dashboard',
    });

    document.body.insertAdjacentElement('beforeend', this.analyticscontainer);
    let footerdivs = document
      .getElementById('footerContact')
      .querySelectorAll('div');
    footerdivs[footerdivs.length - 1].insertAdjacentHTML(
      'beforeend',
      '<h2 class="analytics-dashboard-open">analytics</h2>'
    );
    this.clickhandler();
  }

  clickhandler() {
    [...document.querySelectorAll('.analytics-dashboard-open')].forEach(
      (el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.analyticscontainer.classList.add('open');
          !this.pageviewsloaded ? this.getpageviews() : false;
          !this.timeonpageloaded ? this.gettimeonpage() : false;
          !this.sourcesloaded ? this.getsources() : false;
          !this.landingloaded ? this.getlandingpages() : false;
          !this.mediumloaded ? this.getmedium() : false;
          !this.contentsummaryloaded ? this.getcontentsummary() : false;
        });
      }
    );
    [...document.querySelectorAll('.analytics-dashboard-close')].forEach(
      (el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.analyticscontainer.classList.remove('open');
        });
      }
    );
  }

  getpageviews() {
    fetch(`${this.dataurl}?uri=${this.path}&type=pageview`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.initializechart(data);
        this.pageviewsloaded = true;
      });
  }

  gettimeonpage() {
    fetch(`${this.dataurl}?uri=${this.path}&type=timeonpage`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.displaytimeonpage(data);
        this.timeonpageloaded = true;
      });
  }

  getsources() {
    fetch(`${this.dataurl}?uri=${this.path}&type=source`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.displaysource(data);
        this.sourcesloaded = true;
      });
  }

  getmedium() {
    fetch(`${this.dataurl}?uri=${this.path}&type=medium`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.displaymedium(data);
        this.mediumloaded = true;
      });
  }

  getlandingpages() {
    fetch(`${this.dataurl}?uri=${this.path}&type=landing`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.displaylandingpage(data);
        this.landingloaded = true;
      });
  }

  initializechart(data) {
    let loader = document.getElementById(`${this.pageviewsdivclass}-loader`);
    loader.parentNode.removeChild(loader);
    let labels = [];
    let chartdata = [];
    data.forEach((item) => {
      labels.push(item.dimensions[0]);
      chartdata.push(parseInt(item.metrics[0].values[0]));
    });
    let ctx = document
      .getElementById('analytics-pageviews-chart')
      .getContext('2d');
    let myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,

        datasets: [
          {
            label: 'pageviews per day',
            backgroundColor: 'rgba(0,56,100,0.2)',
            data: chartdata,
            borderWidth: 1,
          },
        ],
      },
    });
  }

  chartcolourthreshold(top, current) {
    let greenthreshold = current >= (2 / 3) * top;
    let amberthreshold = current < (2 / 3) * top && current >= (1 / 3) * top;
    let redthreshold = current < (1 / 3) * top;
    if (greenthreshold) {
      return 'rgba(38, 166, 91, 0.2)';
    } else if (amberthreshold) {
      return 'rgba(232, 126, 4, 0.2)';
    } else if (redthreshold) {
      return 'rgba(207, 0, 15, 0.2)';
    } else {
      return 'rgba(108, 122, 137, 0.2)';
    }
  }

  displaytimeonpage(data) {
    console.log(data);
    return false;
  }

  displaysource(data) {
    let loader = document.getElementById(`${this.sourcedivclass}-loader`);
    loader.parentNode.removeChild(loader);
    let labels = [];
    let chartdata = [];
    let backgroundColor = [];
    let topval = 0;
    data.forEach((entry, i) => {
      if (i <= 10) {
        i === 0 ? (topval = entry.metrics[0].values[0]) : false;
        labels.push(entry.dimensions[0]);
        chartdata.push(entry.metrics[0].values[0]);
        backgroundColor.push(
          this.chartcolourthreshold(topval, entry.metrics[0].values[0])
        );
        // document.querySelector(`.${this.sourcedivclass}`).insertAdjacentHTML("beforeend", `<div><strong>${entry.dimensions[0]}</strong> - ${entry.metrics[0].values[0]}</div>`);
      }
    });
    let ctx = document
      .getElementById('analytics-sources-chart')
      .getContext('2d');
    let myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'sources',
            backgroundColor: backgroundColor,
            data: chartdata,
            borderWidth: 1,
          },
        ],
      },
    });
    return false;
  }

  displaymedium(data) {
    let loader = document.getElementById(`${this.mediumdivid}-loader`);
    loader.parentNode.removeChild(loader);
    let labels = [];
    let chartdata = [];
    let backgroundColor = [];
    let topval = 0;
    data.forEach((entry, i) => {
      if (i <= 10) {
        i === 0 ? (topval = entry.metrics[0].values[0]) : false;
        labels.push(entry.dimensions[0]);
        chartdata.push(entry.metrics[0].values[0]);
        backgroundColor.push(
          this.chartcolourthreshold(topval, entry.metrics[0].values[0])
        );
        // document.querySelector(`.${this.sourcedivclass}`).insertAdjacentHTML("beforeend", `<div><strong>${entry.dimensions[0]}</strong> - ${entry.metrics[0].values[0]}</div>`);
      }
    });
    let ctx = document
      .getElementById('analytics-medium-chart')
      .getContext('2d');
    let myChart = new Chart(ctx, {
      type: 'bar',
      backgroundColor: '#000',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'medium',
            backgroundColor: backgroundColor,
            data: chartdata,
            borderWidth: 1,
          },
        ],
      },
    });
    return false;
  }

  displaylandingpage(data) {
    let loader = document.getElementById(`${this.landingdivclass}-loader`);
    loader.parentNode.removeChild(loader);
    data.forEach((entry, i) => {
      i <= 10
        ? document
            .querySelector(`.${this.landingdivclass}`)
            .insertAdjacentHTML(
              'beforeend',
              `<div><a href="${entry.dimensions[0].replace('index.html', '')}?testing"><strong>${entry.dimensions[0].replace('index.html', '')}</strong> - ${entry.metrics[0].values[0]}</a></div>`
            )
        : false;
    });
    return false;
  }

  getcontentsummary() {
    const sectionid = section.sectionid();
    [...document.querySelectorAll('div')].forEach((el) => {
      el.dataset.contentid
        ? document
            .querySelector(`#${this.contentsummaryid}`)
            .insertAdjacentHTML(
              'beforeend',
              `
                <div class="">${el.dataset.contentname} - last modified ${el.dataset.modified} <a href="https://t4.gla.ac.uk/terminalfour/page/content#edit/${sectionid}/${el.dataset.contentid}">edit</a></div>
            `
            )
        : false;
    });
    this.contentsummaryloaded = true;
  }
}
